import React from 'react';

import CheckboxInput from 'ui-library/inputs/CheckboxInput';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import {InputChangeEvent} from 'util/Types';

export default function TrialSampleCheckbox(props: {
  disabled: boolean;
  onChange: (checked: boolean) => void;
  checked: boolean;
}): JSX.Element {
  return (
    <div>
      <div className="u-flex-display">
        <CheckboxInput
          id="trial-sample-checkbox"
          label=""
          checked={props.checked}
          onChange={(e: InputChangeEvent) => {
            props.onChange(e.target.checked);
          }}
          disabled={props.disabled}
        />
        <FieldLabel label="Configure as a trial sample" htmlFor="trial-sample-checkbox" />
      </div>
      <div className="u-padding-left u-base-text">This cannot be disabled once it is enabled.</div>
    </div>
  );
}
